import { CheckIcon } from '@heroicons/react/20/solid';
import type { PlayerPack } from '@library/types/playerPacks/playerPacks';

export interface PlayerPacksRowProps {
  onClickPlayerPack: (playerPackId: string) => void;
  playerPack: PlayerPack;
}

export const PlayerPacksRow = ({
  onClickPlayerPack,
  playerPack
}: PlayerPacksRowProps) => {
  const {
    createdAt,
    canFade,
    id: playerPackId,
    placeByTime,
    title
  } = playerPack;

  return (
    <div
      aria-hidden="true"
      className="border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 text-2xs relative flex size-full min-h-16 cursor-default items-center border-b pl-4 hover:cursor-pointer xl:text-xs"
      data-testid={`player-pack-${playerPackId}`}
      onClick={() => onClickPlayerPack(playerPackId)}
      role="button"
    >
      <p className="w-[10%] px-3" data-testid="player-pack-id">
        {playerPackId}
      </p>
      <p className="w-2/5 px-3" data-testid="title">
        {title}
      </p>
      <p className="w-1/5 px-3" data-testid="place-by-time">
        {placeByTime}
      </p>
      <p className="w-1/5 px-3" data-testid="created-at">
        {createdAt}
      </p>
      <p className="w-1/5 px-3" data-testid="created-at">
        {canFade ? <CheckIcon className="text-status-success size-5" /> : ''}
      </p>
    </div>
  );
};
